// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1q1vu","label":"Radio_label__2BdkC","checkMark":"Radio_checkMark__nk_xw","disabled":"Radio_disabled__2DfnN"};